<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <section class="basic-elements">
              <div class="row">
                <div class="col-sm-12">
                  <a class="btn btn-secondary float-right top-back-button" @click.prevent="back()"><i class="fa fa-arrow-left"></i></a>
                  <h2 class="content-header">{{ $t("labels.editUser") }}</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="px-3">
                        <div class="card-header">
                          <h4 class="card-title" id="basic-layout-form">{{ user.name }} {{ user.surname }}</h4>
                        </div>
                        <form class="form">
                          <user-form :user="user" :newPass="newPass" />
                          <div class="form-actions">
                            <button type="button" class="btn btn-danger mr-1" @click.prevent="back()">
                              <i class="fa fa-arrow-left"></i> {{ $t("labels.back") }}
                            </button>
                            <button type="button" class="btn btn-success" @click.prevent="updateMe()">
                              <i class="icon-note"></i> {{ $t("labels.save") }}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <dev-footer />
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user";
import UserForm from './UserForm'
import DevFooter from '../DevFooter'

export default {
  components: {
    UserForm,
    DevFooter
  },
  data: () => {
    return {
      userErrors: [],
      pwdErrors: [],
      newPass: {},
      user: {},
      currentEmail: ''
    };
  },
  created() {
    this.loadMe();
  },
  methods: {
    back() {
      this.$router.push({ name: 'home'})
    },
    loadMe: async function() {
      const result = await UserService.me()
      this.user = result.data
      this.currentEmail = result.data.email
    },
    updateMe: async function() {
      if (this.newPass.password && this.newPass.confirmPassword && this.newPass.password.length > 0 && this.newPass.confirmPassword.length > 0) {
        if (this.newPass.password.length < 8) {
          this.pwdErrors.push(this.$t("errors.passwordLength"))
        }
        if (this.newPass.password != this.newPass.confirmPassword) {
          this.pwdErrors.push(this.$t("errors.dontMatch"))
        }
      }

      if (this.user.name.length == 0) {
        this.userErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.name')]))
      }

      if (this.user.surname.length == 0) {
        this.userErrors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.surname')]))
      }

      if (this.user.email.length == 0) {
        this.userErrors.push(this.$t("errors.cantBeEmpty", ['E-mail']))
      }

      if (!this.emailValidator(this.user.email)) {
          this.userErrors.push(this.$t("errors.invalidEmail"))
      }

      if (this.userErrors.length == 0 && this.pwdErrors.length == 0) {
        if (this.newPass.password && this.newPass.confirmPassword) {
          this.user.newPass = this.newPass
        } 
        this.user.currentEmail = this.currentEmail
        const result = await UserService.update(this.user)
        if (result.data.success == true) {
          this.$cookies.set("dravet_language",this.user.language,"30d")
          if (this.user.language) {
            this.$i18n.locale = this.user.language
          }
          this.$miniToastr.success(this.$t("flash.updateSuccess", [this.$t("models.user")]))
        } else {
          for (let userError in result.data.userErrors) {
            this.userErrors.push(result.data.userErrors[userError].msg)
          }
          for (let passwordError in result.data.passwordErrors) {
            this.pwdErrors.push(result.data.passwordErrors[passwordError].msg)
          }
          this.$miniToastr.error(this.userErrors.concat(this.pwdErrors).toString().split(",").join("<hr/>"))
        }
      } else {
        this.$miniToastr.error(this.userErrors.concat(this.pwdErrors).toString().split(",").join("<hr/>"))
        this.userErrors = []
        this.pwdErrors = []
      }
    },
    emailValidator(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
    },
    back: function() {
      this.$router.push({ name: 'home' })
    }
  }
};
</script>

<style>
</style>
